/*
 * @Author: 孙福聪
 * @Date: 2019-01-22 14:58:31
 * @Last Modified by: 史和祥
 * @Last Modified time: 2019-03-16 14:05:48
 */
const state = {
  task: [],
  deleteControl: [] /** 删除控件列表 */,
  taskInfo: {},
  modules: ""
};
const mutations = {
  setModules(store, data) {
    const storeData = store;
    storeData.modules = data;
  },
  setTaskInfo(store, data) {
    const storeData = store;
    storeData.taskInfo = data;
  },
  postTaskScene1(store, data) {
    // 保存案例场景接口
    const storeData = store;
    storeData.task = data.SceneList;
  },
  addDepartmentData(store, data) {
    const storeData = store;
    const obj = {};
    obj.type = data;
    obj.departmentName = "";
    if (
      data === "领导办公室" ||
      data === "我的办公室" ||
      data === "民意调查中心" ||
      data === "首页大厅"
    ) {
      obj.departmentName = data;
    }
    obj.list = [];
    storeData.task.push(obj);
  },
  deleteDepartmentData(store, data) {
    const storeData = store;
    storeData.task.splice(data, 1);
  },
  addQues(store, data) {
    const storeData = store;
    storeData.task.forEach((item, index) => {
      if (item.type === data.type) {
        storeData.task[index].list.push(data.listChild);
      }
    });
  },
  emptyDeleteControlList(store) {
    // 用于切换任务的时候 如果没保存就清空删除的任务
    const storeData = store;
    storeData.deleteControl = [];
  },
  deleteControl(store, data) {
    const storeData = store;
    storeData.deleteControl.push(data);
  },
  deleteQues(store, data) {
    const storeData = store;
    storeData.task.forEach((item, index) => {
      if (item.type === data.type) {
        storeData.task[index].list.splice(data.deleteIndex, 1);
      }
    });
  },
  changeFunc(store, data) {
    const storeData = store;
    storeData.task[data.index].departmentName = data.departmentName;
    console.log(storeData.task, "storeData.task");
  }
};
export default {
  state,
  mutations
};
